import { render } from "./ReferralReadiness.vue?vue&type=template&id=545bedd9&ts=true"
import script from "./ReferralReadiness.ts?vue&type=script&lang=ts&external"
export * from "./ReferralReadiness.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__